import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Hotel } from 'frontend-utils/models';

type ImportantDay = {
  day: string;
  label: '0' | '1' | '2' | '3';
};

export default class Yearoverview extends Model {
  [Type] = 'yearoverview' as const;

  @belongsTo('hotel', { async: false, inverse: null })
  declare hotel: Hotel;

  @attr() declare importantDays: ImportantDay[];
  @attr('number') declare year: number;
}
